import React, { useEffect, useRef, useState } from 'react'

export default function ScrollReveal({ 
  children, 
  className = '', 
  delay = 0, 
  duration = 800, 
  threshold = 0.05,
  direction = 'up' // 'up', 'down', 'left', 'right', 'none'
}) {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true)
          observer.unobserve(entry.target) // Animer kun én gang for et roligt udtryk
        }
      },
      {
        threshold,
        rootMargin: '0px 0px -60px 0px', // Trigger lidt før elementet er helt synligt
      }
    )

    const currentRef = ref.current
    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [threshold])

  // Definer start-positioner baseret på retning
  const getDirectionStyles = () => {
    if (isIntersecting) return 'translate-x-0 translate-y-0 opacity-100'
    
    switch (direction) {
      case 'up':
        return 'translate-y-10 opacity-0'
      case 'down':
        return '-translate-y-10 opacity-0'
      case 'left':
        return 'translate-x-10 opacity-0'
      case 'right':
        return '-translate-x-10 opacity-0'
      case 'none':
      default:
        return 'opacity-0'
    }
  }

  return (
    <div
      ref={ref}
      className={`transition-all ease-out ${getDirectionStyles()} ${className}`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  )
}
